import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "individualEnabled",
    "individualSection",
    "amountRow",
    "amountInput",
    "fieldEditor",
    "applyField",
    "paid",
    "paidAction"
  ]

  connect() {
    this.syncAmountRows()
    if (this.hasPaidTarget) this.paidTarget.indeterminate = this.paidTarget.dataset.indeterminate === "true"
  }

  toggleIndividualAmounts() {
    this.individualSectionTarget.classList.toggle("hidden", !this.individualEnabledTarget.checked)
    this.syncAmountRows()
  }

  activateField(event) {
    const field = event.currentTarget.dataset.field
    const editor = this.fieldEditorTargets.find((candidate) => candidate.dataset.field === field)

    editor?.classList.remove("hidden")
    event.currentTarget.closest(".form-control")?.classList.add("hidden")
    this.enableApplyField(field)
  }

  markFieldApplied(event) {
    this.enableApplyField(event.currentTarget.dataset.field)
  }

  paidChanged() {
    this.paidTarget.indeterminate = false
    this.paidActionTarget.value = this.paidTarget.checked ? "paid" : "unpaid"
  }

  syncAmountRows() {
    if (!this.hasIndividualEnabledTarget) return

    const individualAmountsEnabled = this.individualEnabledTarget.checked
    this.amountRowTargets.forEach((row) => {
      const inputs = this.amountInputTargets.filter((candidate) => candidate.dataset.expenseId === row.dataset.expenseId)
      inputs.forEach((input) => {
        input.disabled = !individualAmountsEnabled
      })
    })
  }

  enableApplyField(field) {
    const marker = this.applyFieldTargets.find((candidate) => candidate.dataset.field === field)
    if (marker) marker.disabled = false
  }
}
